'use client';

export const isCypress = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return !!window.Cypress;
};
